const FacultyData = [
  {
    index: 0,
    name: 'Dr. Subhra Debdas',
    src: require('../assets/images/facultyImages/faculty1.jpg'),
    review:
      "As the Faculty Incharge, I encourage UiPath Student Community KIIT members to embrace curiosity, continuous learning, and collaboration. Stay committed to honing your automation skills, as they are invaluable in today's dynamic tech landscape. Each and every challenge is an opportunity to grow. Strive for excellence and contribute meaningfully to the community. Your dedication will undoubtedly shape a promising future in the field of robotic process automation. Best wishes on your UiPath journey!",
  },
  {
    index: 1,
    name: 'Dr. Abhishek Ray',
    src: require('../assets/images/facultyImages/faculty2.jpg'),
    review:
      "In my role as the Academic Supervisor, I urge members of the UiPath Student Community at KIIT to foster a spirit of curiosity, persistent learning, and teamwork. It's crucial to stay dedicated to refining your automation abilities, given their immense significance in the ever-evolving tech environment. Consider every challenge as a chance for personal and collective advancement. Aim for exceptional performance and make valuable contributions to the community. Your unwavering commitment will undeniably shape a bright future within the realm of robotic process automation. Wishing you the very best on your UiPath journey!",
  },
]

export default FacultyData
